<template>
    <div
        class=" h-8 w-16 p-0.75 rounded-full border border-zinc-700 bg-zinc-900 cursor-pointer"
        :data-testid="testid || undefined"
        :data-checked="modelValue"
        @click="toggle"
    >
        <div class="h-6 w-6 rounded-full transition-all duration-300" :class="{'translate-x-8.25 bg-green-600': modelValue, 'bg-titles': !modelValue}"></div>
    </div>
</template>

<script>
export default {
    name: 'Toggle',
    props: {
        modelValue: {
            default: false,
        },
        testid: {
            type: String,
            default: '',
        },
    },
    computed: {
        backgroundColor() {
            return this.value ? '#34C759' : '#232323'
        },
        dotX() {
            return this.value ? 21 : 3
        },
    },
    data() {
        return {
            value: this.modelValue,
        }
    },
    watch: {
        modelValue(val) {
            this.value = val
        },
    },
    methods: {
        toggle() {
            this.value = !this.value
            this.$emit('update:modelValue', this.value)
        },
    },
}
</script>